// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DXq-F","buttons":"styles_buttons__HhTvC"};